import React from "react";

export class FleetTaskCommitButtons extends React.Component {
    render() {
        if (!this.props.pending) return <div />;

        if (this.props.mode === "LAUNCHING") {
            return (
                <div className="modal-host" style={{ float: "right" }}>
                    <div className="action-button"
                        onClick={() => this.props.onCancelTask()}>Cancel
                    </div>
                </div>);
        }

        return (
            <div className="modal-host" style={{ float: "right" }}>
                <div className="action-button"
                    onClick={() => this.props.onCancelTask()}>Cancel
                </div>
                <div className="action-button"
                    onClick={() => this.props.onCommitTask()}>Commit
                </div>
            </div>
        );
    }
}